<template>
  <div>
    <modals-container name="modal1" />
    <v-dialog name="dialog" />
    <div class="admin_title">报名管理</div>
    <div class="gj_top_class">
      <input name="" type="button" class="btn_s_gj" @click="search(filters)" />
      <input name="" type="text" class="put_gj" v-model="filters.name" />
      <select name="enrollType" v-model="filters.type" @change="search(filters)">
        <option value="">报名类型</option>
        <option v-for="item in selects.enrollType" v-bind:key="item.value" :value="item.value">{{item.label}}</option>
      </select>
      <select name="state" v-model="filters.state" @change="search(filters)">
        <option value="">状态</option>
        <option value="1">上架</option>
        <option value="0">下架</option>
      </select>
      <a @click="to('enroll', 'void')">新增报名</a>
    </div>
    <div class="training_list" style="min-height: 480px;">
      <!--暂无报名提示-->
      <h5 class="none_ts" v-if="lists.length == '0'">
        <img src="@/assets/images/none_data.jpg" alt="">
      </h5>
      <!--暂无报名提示-->
      <dl v-for="item in lists" :key="item.id">
        <dt style="position: relative;">
          <span class="enroll_badge" style="position: absolute; top: -12px; z-index: 12;">{{item.unCofirmUserCnt}}人未审核</span>
          <div style="position: absolute; top: 0; z-index: 3;">
            <img v-if="!item.cover || item.cover == ''" src="@/assets/images/zy_default.png" width="220" height="94">
            <img v-if="item.cover && item.cover!==''" :src="item.cover" width="220" height="94" />
          </div>
          <div style="position: absolute; top: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.4); z-index: 4;"></div>
          <h3 style="position: relative; z-index: 6; top: 10px; text-align: left; font-size: 16px; overflow: auto; line-height: 16px;">{{item.name}}</h3>
          <ul class="col_2_2 total-scope-train" style="z-index: 50;">
            <p>操作</p>
            <li class="total-scope-tan" :style="{ 'width': (item.type == '04') ? '130px' : '100%' }" style="display: none; height: 100px;">
              <a v-debounce-click @click="to('enroll', item.id)" style="display: inline-block; width: 60px;">编辑报名</a>
              <a v-debounce-click @click="del(item.id)" style="display: inline-block; width: 60px;">删除报名</a>
              <a v-debounce-click @click="to('enrollAudit', item.id)" style="display: inline-block; width: 60px;">报名情况</a>
              <a v-if="item.type == '04'" v-debounce-click @click="to('enrollSignin', item.id)" style="display: inline-block; width: 60px;">签到情况</a>
              <a v-if="item.type == '04'" v-debounce-click @click="to('enrollCheck', item.id)" style="display: inline-block; width: 60px;">学习情况</a>
              <a v-if="item.type == '04'" v-debounce-click @click="show1(item.id)" style="display: inline-block; width: 60px;">签到二维码</a>
            </li>
          </ul>
        </dt>
        <dd>
          <span class="red_font col_2_1">
            {{item.state == '0' ? '已下架' : '已上架'}}
            {{item.cost == '0' ? '免费' : '￥'+item.cost}}
          </span>
          <span class="col_2_2" v-if="item.number == 0">{{item.signUserCnt}}人已报名</span>
          <span class="col_2_2" v-else>{{item.signUserCnt}} / {{item.number}} 人已报名</span>
        </dd>
      </dl>
    </div>
    <div class="zy_list_bottom mtf30">
      <dl>
        <dt v-if="cnt && cnt > 0">共{{cnt}}个报名</dt>
        <dd v-if="cnt>0">
          <paginate :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </dd>
      </dl>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
  import {init} from '@/assets/js/public'
  import Paginate from 'vuejs-paginate'
  import config from '@/config'
  import api from '@/api'
  import utils from '@/utils'
  import { mapState } from 'vuex'
  import qrCode from './qrcode'
  export default {
    components: { Paginate },
    data () {
      return {
        lists: [],
        paginationDefaults: {
          pageNo: 1,
          pageSize: 12
        },
        filters: {
          pageNo: 1,
          pageSize: 12,
          name: '',
          type: '',
          state: ''
        },
        selects: {
          enrollType: []
        },
        pages: 0,
        cnt: 0
      }
    },
    mounted () {
      this.selects.enrollType = this.enrollType // 先循环出selects下拉框
      this.search(this.filters) //  默认无搜索条件获取列表
      this.$on('data-prepared', function () {
        this.$nextTick(() => {
          init()
        })
      })
    },
    methods: {
      show1 (id) {
        this.$modal.show(qrCode, {
          id: id,
        })
      },
      to (path, id) {
        this.$router.push({
          path: path + '/' + id
        })
      },
      clickCallback (pageNum) {
        this.filters.pageNo = pageNum
        this.search(this.filters)
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: '删除',
          text: '确认删除吗？',
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      del (id) {
        if (id) {
          var that = this
          this.confirmBox({
            yes: function () {
              api.get(config.enrollApiPath, '/signupinfo/delete', { id: id }, r => {
                that.$toasted.show('删除成功')
                that.search(that.filters)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      search (filters) {
        if (!filters) { filters = {} }
        var that = this
        api.post(config.enrollApiPath, '/signupinfo/search', filters, function (r) {
          if (r.data) {
            that.lists = r.data
          } else {
            that.lists = []
          }
          that.cnt = r.cntData
          that.pages = Math.ceil(r.cntData / filters.pageSize)
          that.$emit('data-prepared')
        })
      }
    },
    computed: {
      ...mapState('dropdowns', ['enrollType'])
    }
  }
</script>

<style scoped>
  .class_list dl dd li a:hover {
    color: #666;
  }
  .actions span { cursor: pointer; }
  .actions span:hover {
    color: #ff3633;
  }
  .enroll_badge {
    background-color: #f56c6c;
    border-radius: 10px;
    color: #fff;
    display: inline-block;
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
  }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/enroll/list.vue